/* eslint-disable import/order */
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import Scale from './Scale';

interface IProps {
    isAuthenticated: boolean;
}

export const OpensiteRoutes: React.FC<IProps> = ({ isAuthenticated }) => {
    const location = useLocation();
    return isAuthenticated ? (
        <Navigate to={`/`} state={{ from: location }} replace />
    ) : (
        <>
            <Outlet />
            {/* <Scale /> */}
        </>
    );
};
